import { types, actions } from './requests'
export const CREATEMASTER_TYPES = {
    ...types('CREATEMASTER'),
}
export const CREATEMASTER_ACTIONS = {
    ...actions('CREATEMASTER'),
}